import styled from "styled-components/macro";
import { Link } from "@ds/react";

export const BackLink = styled(Link)(({ theme }) => ({
  "> *": {
    gap: "10px",
    display: "flex",
    textDecoration: "none",
    fontSize: "14px",
    marginBottom: "16px",
  },

  [theme.breakpoint.lg()]: {
    "> *": {
      fontSize: "16px",
    },
  },
}));
